import React, { FC } from 'react';
import moment from 'moment';
import clsx from 'clsx';
import { Plan } from '../interfaces/PlanIntrfaces';

const MultiEditPlans: FC<{ plan: Plan }> = ({ plan }) => {
  const headerStyle: string = 'py-4 text-left text-gray-40 text-sm font-medium font-effra';

  return (
    <div
      className="grid gap-4 items-center border-b-1 border-gray-20"
      style={{
        gridTemplateColumns: '1.5fr repeat(2, minmax(0, 1fr))'
      }}
    >
      <h4 className={clsx(headerStyle, 'text-right mr-7 break-all')}>{plan.code}</h4>
      <h4 className={headerStyle}>
        {moment(plan.start_dt).isValid() ? moment(plan.start_dt).format('MM/DD/YYYY') : ''}
      </h4>
      <h4 className={headerStyle}>{moment(plan.end_dt).isValid() ? moment(plan.end_dt).format('MM/DD/YYYY') : ''}</h4>
    </div>
  );
};

export default MultiEditPlans;
